<!-- 
    가장 최근의 SnapshotData를 기준으로 Type별 Status의 현황을 보여주는 그래프

 -->

 <template>
    <b-row class="w-100 d-flex justify-content-center align-items-center" style="padding-top: 10px; height:80%; margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        
        <apexchart v-if="series && !thereIsNoData" id="chart" style="flex:3;"
        width="100%" height="90%" ref="apexchart" 
        :options="chartOptions"
            :series="series" />
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ChartTable from "./ChartTable.vue";
import {getProjectPeriodByHistory} from '@/components/chatter/util/graphUtils';
export default {
    name: 'ChatterActivationGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts,
        ChartTable
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
    
        this.todayDate = new Date(this.today);
        this.currentChatter = this.dashboardData.currentChatter;
        // this.setSeries();
        // this.setLabels();
        
        if(this.currentChatter.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.startDate = this.dashboardData.projectInfo.startDate;
            this.endDate = this.dashboardData.projectInfo.endDate;

            // 시작, 종료 날짜 둘중 하나라도 비어있으면 히스토리에서 시작, 종료 가져옴
            if(this.startDate == '' || this.endDate == '') {
                const [historyStart, historyEnd] = getProjectPeriodByHistory(this.dashboardData.history);

                this.startDate = historyStart;
                this.endDate = historyEnd;
            }
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                if(this.isFlexible) {
                    
                    this.series = [];
                    this.chartOptions.xaxis.categories = [];
                    this.reloadGraph();
                }
            }
        },
    },
    data() {
        return {
            todayDate: '',
            historyData:'',
            currentChatter: '',
            thereIsNoData:false,
            loading : false,
            currentChatterData : '',
            columnNames: [],
            snapshotData :[],
            series: [],
            labelArray : [],
            tableData: '',
            chartOptions: {
                chart: {
                    type: 'bar',
                    stacked: true,
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                    return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                colors: ['#176BA0', '#1BD4D4' ],
                series: [],
                plotOptions: {
                    bar: {
                    columnWidth: "95%",
                    // strokeWidth: 2,
                    // borderRadius: 5,
                    // borderRadiusApplication: "end",
                    }
                },
                dataLabels: { enabled: false },
                grid: {
                    xaxis: {
                        lines: {
                            show: this.isFlexible
                        }
                    },
                    yaxis: {
                        lines: {
                            show: this.false
                        }
                    }
                },
                xaxis: {
                    type: "numeric",
                    min: 0,
                    max: 0,
                    // tickPlacement: 'on',
                    categories: [],
                    tickAmount: 0,
                    labels: { 
                        show : this.isFlexible,
                        formatter: x => {
                            return this.labelArray[x]
                        }
                    },
                },
                yaxis: {
                    labels: {
                        show: this.isFlexible
                    },
                    axisBorder: {
                        show: this.isFlexible,
                        // color: "#000000"
                    }
                },
                legend: {
                    show: true,
                    showForSingleSeries: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: this.isFlexible ? '14px' : '12px'
                },
                tooltip: {
                    onDatasetHover: {
                    highlightDataSeries: true,
                    },
                    x: { formatter: x => { return 'Days ' + this.labelArray[x - 0.5] + ' ~ ' + this.labelArray[x + 0.5]; } }
                }
            },
        }
    },
    methods: {

        getLabelArray(dataArray) {
            let maxActivationDays = 0;
            let start = 0;
            
            // Get Max Activation Days
            dataArray.forEach(data => {

                let chatterDate = '';

                // 최초 생성 기록일때는 생성날짜로 비교
                if(data.updatedDate == '') {
                    chatterDate = data.creationDate;
                } else {
                    chatterDate = data.updatedDate;    
                }

                // 가장 마지막 생성/수정날짜와 오늘 날짜의 차 계산
                let activationDays = this.getDiffDate(chatterDate, this.todayDate);

                // 최댓값 갱신
                if(maxActivationDays < activationDays) {
                    maxActivationDays = activationDays;
                }
            });

            // 기본값 1;
            let interval = 7;

            if(this.isFlexible) {
                // 사용자 입력 interval이 있으면 대입
                if(this.filters.interval != '') {
                    interval = this.filters.interval;
                }
            }

            // 1 ~ maxInterval 까지 사용자가 입력한 interval 만큼 
            // 배열을 만들고 값 초기화 ex) start = 1, index = 0, interval * 3 일 때 1 + 0 * 3 = 1
            let labelArray = Array.from({ length: Math.ceil((maxActivationDays - start + 1) / interval) + 1}, (_, index) => start + index * interval);

            this.labelArray = labelArray;

            return labelArray;
        },

        countData(labelArray, dataArray) {

            // interval 초기화
            let interval = 7;
            if(this.isFlexible) {
                interval = this.filters.interval != '' ? this.filters.interval : interval;
            }

            interval = Number(interval);

            let arraySize = labelArray.length;

            let countObj = {
                'TO_DO' : new Array(arraySize).fill(0),
                'IN_PROGRESS' : new Array(arraySize).fill(0)
            }

            for(let i = 0; i < labelArray.length; i++) {
                let current = labelArray[i];
                let next = labelArray[i] + interval;
                let count = 0;
                dataArray.forEach(data=> {
                    // 종료된 이슈에 대해
                    // 최초 생성날짜 - 완료 날짜 구하기
                    let diffDate = this.getDiffDate(data.creationDate, this.todayDate);
                    // 설정한 interval 보다 작거나 같으면 해당 개수에 카운트
                    if(diffDate >= current && diffDate < next) {
                        // TO_DO, IN_PROGRESS를 제외한 STATUS는 전처리 단계에서 이미 제외하였음
                        countObj[data.status][i]++;
                    }
                })
            }

            let series = [
                {
                    name: 'To Do',
                    data: Array.from({length: labelArray.length - 1},
                        (_, i)=>({
                            x: 0.5 + i,
                            y: countObj['TO_DO'][i],
                            ... ({fillColor: '#176BA0', strokeColor: '#176BA0'})

                        }))
                },
                {
                    name: 'In Progress',
                    data: Array.from({length: labelArray.length - 1},
                        (_, i)=>({
                            x: 0.5 + i,
                            y: countObj['IN_PROGRESS'][i],
                            ... ({fillColor: '#1BD4D4', strokeColor: '#1BD4D4'})
                        }))
                },
            ];
            
            this.chartOptions.xaxis.max = labelArray.length - 1;
            this.chartOptions.xaxis.tickAmount = labelArray.length - 1;
            this.series = series;

            this.labelArray = labelArray;
            this.chartOptions.xaxis.categories = labelArray;

            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions(this.chartOptions);
                // this.$refs.apexchart.forceUpdate();
            }

            return series;
        },

        visualizeGraph() {
            let dataArray = this.currentChatter;

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;

                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                dataArray = dataArray.filter(item => {

                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) && 
                        BUSINESS_CATEGORY.includes(item.businessCategory) 
                    );
                });
            }

            // 가장 최근에 업데이트된 상태로 중복 제거
            // dataArray = this.getLastModifiedChatter(dataArray);

            // Status가 TO_DO, IN_PROGRESS인 데이터만 필터링
            const availableStatusArray = ['TO_DO', 'IN_PROGRESS'];
            dataArray = dataArray.filter(data => availableStatusArray.includes(data.status));
            
            let labelArray = this.getLabelArray(dataArray);

            let series = this.countData(labelArray, dataArray);

            // this.series = series;

            // this.setLabels();
        },

        getDiffDate(start, end) {
            const creationDate = new Date(start);
            // 이슈 실제 종료 날짜
            const actualDate = new Date(end);
            
            // 종료 날짜 - 생성 날짜 (MSec 단위로 반환)
            const diffMSec = actualDate.getTime() - creationDate.getTime();

            // MSec을 Day로 변환
            let diffDate = diffMSec / (24*60*60*1000);

            return diffDate;
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        // setLabels() {
        //     this.chartOptions.xaxis.categories = this.label;

        //     // 차트를 업데이트
        //     if (this.$refs.apexchart) {
        //         this.$refs.apexchart.updateOptions({
        //             xaxis: {
        //                 categories: this.label,
        //             },
        //         });
        //     }
        // },
        setTable() {
            this.tableData = this.data.table;

        },
    },
}
</script>
<style scoped>
.count-label {
    font-size: 2.25rem !important;
    font-weight: 500;
}
.count-data {
    margin-top: 20px;
    font-size: 2.5rem;
    font-weight: 600;
}
</style>